module.exports = __webpack_public_path__ + "img/error.d2900a4b.jpg";